
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightBacklightButtonslightBacklightButtonsColourOff as ObiLightBacklightButtonslightBacklightButtonsColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-backlight-buttonslight-backlight-buttons-colour-off.js';
 
 
 

 
 export const ObiLightBacklightButtonslightBacklightButtonsColourOff = createComponent({
   react: React,
   tagName: 'obi-light-backlight-buttonslight-backlight-buttons-colour-off',
   elementClass: ObiLightBacklightButtonslightBacklightButtonsColourOffElement,
   events: {
     
   }
  });
 
 